import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    fabChat: false,
    cedulaPaciente: null,
    cargando: false,
    mensaje_modal: null,
    estado_modal: false,
    icono_modal: null
  },
  getters: {
    getFabChat: state => state.fabChat,
    getCedulaPaciente: state => state.cedulaPaciente,
    getCargando: state => state.cargando,
    getEstadoModal: state => state.estado_modal,
    getMensajeModal: state => state.mensaje_modal,
    getIconoModal: state => state.icono_modal
  },
  mutations: {
    setFabChat(state, valor) {
      state.fabChat = valor;
    },
    setCedulaPaciente(state, valor) {
      state.cedulaPaciente = valor;
    },
    setCargando(state, valor) {
      state.cargando = valor;
    },
    cambiarEstadoModal(state, estado) {
      state.estado_modal = estado;
    },
    cambiarMensajeModal(state, mensaje) {
      state.mensaje_modal = mensaje;
    },
    cambiarIconoModal(state, src) {
      state.icono_modal = src;
    }
  },
  actions: {
    setFabChat(context, valor) {
      context.commit("setFabChat", valor);
    },
    setCedulaPaciente(context, valor) {
      context.commit("setCedulaPaciente", valor);
    },
    setCargando(context, valor) {
      context.commit("setCargando", valor);
    },
    cambiarEstadoModal(context, estado) {
      context.commit("cambiarEstadoModal", estado);
    },
    cambiarMensajeModal(context, mensaje) {
      context.commit("cambiarMensajeModal", mensaje);
    },
    cambiarIconoModal(context, src) {
      context.commit("cambiarIconoModal", src);
    }
  }
});

export default store;
